export default __webpack_public_path__ + "static/media/bear2.84f758b1.png";